module.exports = __webpack_public_path__ + "bg.14862d628a383dcc3213.png";


//////////////////
// WEBPACK FOOTER
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/assets/img/pages/bg.png
// module id = ../../../../../src/assets/img/pages/bg.png
// module chunks = main